import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';

import { AuthModule } from '@app/auth';
import { ShellComponent } from './shell.component';

import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidenavPrimaryComponent } from './sidenavs/sidenav-primary.component';

@NgModule({
  imports: [
    RouterModule,
    SharedModule,
    AuthModule,
  ],
  declarations: [
    ShellComponent,
    HeaderComponent,
    FooterComponent,
    SidenavPrimaryComponent
  ],
  exports: [
    FooterComponent
  ]
})
export class ShellModule {
}
